import { SET_USER } from "./action-types";

// action creator : function which returns an action
export const setUser = (user) => ({
  type: SET_USER,
  payload: { user },
});
